import {IAM_SERVICE } from "../utils/constants";
import { getAccessToken } from "../utils/getAlefuser";
import { getSelectedOrganization } from "../utils/selectedOrganization";

export type userResponse = {
  id?: number | null;
  email: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  uuid?: string | null; // Assuming UUID is represented as a string
};

export type usersResponse = {
  totalCount: number
  users: userResponse[]
}

export type FetchUsersParams = {
  search?: string | null;
  pageNumber?: number;
  pageSize?: number;
};

const fetchUsers = async ({ search = null, pageNumber = 0, pageSize = 10 }: FetchUsersParams): Promise<usersResponse> => {
  try {

    const params = new URLSearchParams();

    if (search !== null) params.append('search', search);
    params.append('pageNumber', pageNumber.toString());
    params.append('pageSize', pageSize.toString());

    const URI = `${IAM_SERVICE}/ccl/api/v3/users?${params.toString()}`;
    const req = await fetch(URI, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        'Content-Type': 'application/json',
        'X-Tenantid': getSelectedOrganization()
      }
    })
    if (req.status !== 200) {
      throw new Error('request Error')
    }
    const data: usersResponse = await req.json()
    return data
  } catch (e) {
    console.error(e)
    throw e;
  }
}

export default fetchUsers
